import TourApi from '../../api/TourApi';

const state = {
  hasTourPending: false,
};

const actions = {
  async init({ commit }) {
    const { hasTourPending } = await TourApi.fetchCashflowTourPending();
    commit('setHasTourPending', hasTourPending);
  },
  async markAsDone({ commit }) {
    await TourApi.markAsDone();
    commit('setHasTourPending', false);
  },
};

// mutations
const mutations = {
  setHasTourPending(state, hasTourPending) {
    state.hasTourPending = hasTourPending;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
